import React, { useState, useEffect } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import {
  initialValues,
  validationSchema,
} from "../../componentes/SeleccionarIdioma";
import "../../scss/index.scss";
import imaLogo from "../../imagenes/logo.png";
import { Grid, Image, Segment, Header } from "semantic-ui-react";
import { seleccionar_idioma, selecciona_idioma } from "../../utils/traductor";
import { apiIdioma } from "../../api/idioma";
import { apiUsuario } from "../../api/usuario";
import { ENTORNO } from "../../utils/constantes";
import { isMobile } from "react-device-detect";
import {
  setIdioma,
  getIdioma,
  getemail,
  getpassword,
  getrole,
  setmenuAbajoSeleccionado,
} from "../../utils/variablesLocales";
import { IconoLenguaje } from "../../utils/iconos";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { estiloSegmento } from "../../estilos";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { Form } from "semantic-ui-react";
import Swal from "sweetalert2";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import animacion from "../../imagenes/AnimacionesVarias/LoadingMap.json";
import { Player } from "@lottiefiles/react-lottie-player";

const apiusuario = new apiUsuario();

const apiidioma = new apiIdioma();

export function SeleccionarIdioma(props) {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const navigate = useNavigate();

  const navigateToIngresar = () => {
    navigate(ENTORNO.URL_APLICACION + "/Ingresar");
  };

  const navigateToInicioPasajero = () => {
    setmenuAbajoSeleccionado("Inicio");
    navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  };

  const navigateToInicioConductor = () => {
    setmenuAbajoSeleccionado("Inicio");
    navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");
  };

  const navigateToInicioAdministrador = () => {
    setIdioma("Español");
    setmenuAbajoSeleccionado("Inicio");
    navigate(ENTORNO.URL_APLICACION + "/Administrador/Inicio");
  };

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        navigateToIngresar();
      } catch (error) {
        console.log(error);
      }
    },
  });

  function ScrollTop(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
      target: window ? window() : undefined,
      disableHysteresis: true,
      threshold: 100,
    });

    const handleClick = (event) => {
      const anchor = (event.target.ownerDocument || document).querySelector(
        "#back-to-top-anchor"
      );

      if (anchor) {
        anchor.scrollIntoView({
          block: "center",
        });
      }
    };

    return (
      <Fade in={trigger}>
        <Box
          onClick={handleClick}
          role="presentation"
          sx={{ position: "fixed", bottom: 16, right: 16 }}
        >
          {children}
        </Box>
      </Fade>
    );
  }
  ScrollTop.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
  };

  ////////////////////////////////

  const [idiomas, setIdioma1] =
    useState(
      null
    ); /*esta variable idiomas, maneja el estado del item seleccionado en el combo idioma*/

  /*este es como el load de asp.net*/
  useEffect(() => {
    (async () => {
      try {
        //en caso que existan valores correctos de login en local storage, ingresa automaticamente
        if (getIdioma() === null) {
          setIdioma("Español");
        }

        let Idioma = getIdioma();
        let email = getemail();
        let password = getpassword();

        if (
          email !== "null" &&
          password !== "null" &&
          email !== "" &&
          password !== "" &&
          email !== undefined &&
          password !== undefined
        ) {
          //login
          const response = await apiusuario.IngresarConPasswordEncriptado(
            email,
            password,
            Idioma
          );

          if (response === "Ok") {
            //ingresar a inicio
            if (getrole() === "Pasajero" && isMobile === true) {
              navigateToInicioPasajero();
            }

            if (getrole() === "Conductor" && isMobile === true) {
              navigateToInicioConductor();
            }

            if (getrole() === "Administrador") {
              navigateToInicioAdministrador();
            }
          }
        }

        //obtengo la lista de idiomas para luego cargar el combo
        const response = await apiidioma.obtener();
        setIdioma1(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  ////////////////////////////////

  var idiomaRegistros = [];

  if (idiomas) {
    for (let i = 0; i < idiomas.length; i++) {
      idiomaRegistros.push({
        key: idiomas[i].Nombre,
        text: idiomas[i].Nombre,
        value: idiomas[i].Nombre,
      });
    }
  }

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <form onSubmit={formik.handleSubmit}>
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              {/* <IconButton
                size="large"
                edge="start"
                color="inherit"
                onClick={navigateToIngresar}
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <ArrowBackIcon fontSize="medium" />
              </IconButton> */}
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {seleccionar_idioma}
              </Typography>
              <IconButton
                size="large"
                aria-label="display more actions"
                edge="end"
                color="inherit"
                type="submit"
              >
                <CheckIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Box sx={{ my: 2 }}>
              <Segment style={estiloSegmento.Pasajero}>
                <Grid
                  textalign="center"
                  container
                  style={{ padding: "5em 0em" }}
                >
                  <Grid.Row>
                    <div className="seleccionarIdioma">
                      <Grid.Column style={{ maxWidth: 450 }}>
                        <Image
                          src={imaLogo}
                          className="logoCrearCuenta"
                          centered
                        />
                        <br></br>
                        <Header as="h3">{seleccionar_idioma}</Header>
                        <Form.Field>
                          <Form.Dropdown
                            name="idioma"
                            value={getIdioma()}
                            onChange={(_, data) => {
                              formik.setFieldValue("idioma", data.value);
                              setIdioma(data.value);

                              //muestro back-drop
                              setOpen(true);

                              window.location.reload(true);
                            }}
                            error={formik.errors.idioma}
                            fluid
                            selection
                            // options={idiomaRegistros}

                            options={[
                              {
                                key: "English",
                                text: "English",
                                value: "English",
                              },
                              {
                                key: "Español",
                                text: "Español",
                                value: "Español",
                              },
                              {
                                key: "Português",
                                text: "Português",
                                value: "Português",
                              },
                            ]}
                            placeholder={seleccionar_idioma}
                          ></Form.Dropdown>
                        </Form.Field>
                        {/* <Box sx={{ minWidth: 120 }}>
                          <FormControl fullWidth>
                            <InputLabel
                              variant="standard"
                              htmlFor="uncontrolled-native"
                            ></InputLabel>
                            <NativeSelect
                              value={getIdioma()}
                              inputProps={{
                                name: "idioma",
                                id: "idioma",
                              }}
                              onChange={(event) => {
                                formik.setFieldValue(
                                  "idioma",
                                  event.target.value
                                );
                                setIdioma(event.target.value);
                              }}
                              error={formik.errors.idioma}
                            >
                              {idiomaRegistros.map((opcion) => (
                                <option key={opcion.value} value={opcion.value}>
                                  &nbsp;{opcion.text}
                                </option>
                              ))}
                            </NativeSelect>
                          </FormControl>
                        </Box> */}
                        <br></br>
                        <IconoLenguaje></IconoLenguaje>
                      </Grid.Column>
                    </div>
                  </Grid.Row>
                </Grid>
              </Segment>
            </Box>
          </Container>
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        </React.Fragment>
      </form>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>
    </div>
  );
}
